export default {"src":"/_next/static/media/reuse.8ace5b03.svg","height":28,"width":28,"blurWidth":0,"blurHeight":0};